import React from 'react';

const CostSaving = () => {
  return (
    <svg width='42' height='38' viewBox='0 0 42 38' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M2 2H12.2488L17.4342 8.2449H28.6469L39.5789 20.0408M39.5789 20.0408H31.3799M39.5789 20.0408V11.7143M5.35526 11.7143V36M5.35526 36H20.4539M5.35526 36H2H35.5526M35.5526 36V27.6735M35.5526 36H20.4539M35.5526 36H39.5789M20.4539 36V17.2653'
        stroke='#FBBA14'
        stroke-width='3'
        stroke-linecap='round'
        stroke-linejoin='round'
      ></path>
    </svg>
  );
};

export default CostSaving;
